import { useContext } from 'react';

import { ModalContext } from './context';

export const useModal = () => {
  const modalState = useContext(ModalContext);
  return modalState;
};
